/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-24 10:25:12
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-24 10:25:29
 * @FilePath: /wemeet-admin-new/src/api/recruitment/job.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'
// 查询岗位列表
export function getJobList(data) {
  return request({
    url: '/user/admin/enterprise/job/list',
    method: 'POST',
    data,
  })
}

// 新增岗位
export function addJob(data) {
  return request({
    url: '/user/admin/enterprise/job/addOrUpdate',
    method: 'POST',
    data,
  })
}

// 岗位详情
export function getJobDetail(params) {
  return request({
    url: '/user/admin/enterprise/job/detail',
    method: 'GET',
    params,
  })
}

// 标签列表
export function getTagList() {
  return request({
    url: '/user/admin/enterprise/job/queryCommonTag',
    method: 'GET',
  })
}
